"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPool = function SvgPool(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.564 2.025c-1.744.085-2.615.957-2.615 2.615v11.3M18.342 2.025c-1.744.085-2.615.957-2.615 2.615v11.3M7.801 4.5h7.78m-7.78 3h7.78m-7.78 3h7.78m-7.78 3h7.78M1.047 18.534c1.525.094 2.56-.368 3.107-1.384.541.999 1.409 1.46 2.603 1.384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047 18.534c1.525.094 2.56-.368 3.107-1.384.541.999 1.409 1.46 2.603 1.384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.425 18.534c1.525.094 2.56-.368 3.107-1.384.541.999 1.409 1.46 2.603 1.384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.802 18.534c1.526.094 2.561-.368 3.108-1.384.54.999 1.408 1.46 2.603 1.384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.18 18.534c1.525.094 2.561-.368 3.108-1.384.54.999 1.408 1.46 2.603 1.384M1.047 21.467c1.525.094 2.56-.367 3.107-1.383.541.998 1.409 1.46 2.603 1.383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.425 21.467c1.525.094 2.56-.367 3.107-1.383.541.998 1.409 1.46 2.603 1.383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.802 21.467c1.526.094 2.561-.367 3.108-1.383.54.998 1.408 1.46 2.603 1.383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.18 21.467c1.525.094 2.561-.367 3.108-1.383.54.998 1.408 1.46 2.603 1.383"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPool);
var _default = exports["default"] = Memo;